export default "__VITE_PUBLIC_ASSET__b1b31c89__"